import React from 'react';
import './HowItWorks.css';

import howItWorks1 from '../../../../images/lp/googleV2/HP-howitworks1.webp';
import howItWorks2 from '../../../../images/lp/googleV2/howitworks_2.webp';
import howItWorks3 from '../../../../images/lp/googleV2/HP-howitworks3.webp';
import bazaar from '../../../../images/lp/googleV2/logoticker_bazaar.svg';

const howItWorksData = [
    {
        img: howItWorks1,
        title: 'Get a custom quote',
        desc: 'Get a personalized quote that includes unlimited sessions for one affordable price.',
    },
    {
        img: howItWorks2,
        title: 'Try it for free',
        desc: 'Discuss your goals and select a plan with a laser expert. Your first treatment is free!',
    },
    {
        img: howItWorks3,
        title: 'Unlimited treatments',
        desc: 'Enjoy being hair-free forever with unlimited treatments.',
    },
];

const HowItWorksCard = ({ img, title, desc }) => (
    <div className="googlelp-howitworks-card flex flex-md-column align-items-center w-100">
        <img src={img} alt={title} />
        <div className="googlelp-howitworks-card-text text-left text-md-center">
            <h3 className="googlelp-howitworks-card-title mcl-font-proxima mb-2 font-bold">{title}</h3>
            <p className="googlelp-howitworks-card-desc mcl-font-proxima mb-0">{desc}</p>
        </div>
    </div>
);

export function HowItWorks() {
    return (
        <section>
            <div className="googlelp-container googlelp-howitworks flex flex-column text-center py-5">
                <h2 className="googlelp-howitworks-title mcl-font-greycliff mb-0 pb-2">How it works</h2>
                <p className="googlelp-howitworks-subheader mcl-font-proxima mb-0 pb-4 pb-md-5">
                    Your journey to smooth skin starts here
                </p>
                <div className="googlelp-howitworks-cards justify-content-start justify-content-md-center flex flex-column flex-md-row">
                    {howItWorksData.map((testimonial, index) => (
                        <HowItWorksCard key={index} {...testimonial} />
                    ))}
                </div>
            </div>
            <div className="googlelp-howitworks-quote p-4 flex flex-column flex-md-row align-items-center text-center justify-content-md-center">
                <p className="mcl-font-greycliff mb-3 mb-md-0">“Self-assurance gained is truly priceless”</p>
                <img src={bazaar} alt={'Bazaar'} />
            </div>
        </section>
    );
}

export default HowItWorks;
